const orgWidePaths = ["/screens-manager", "/screens-summary"];

// Validate if path is organization wide feature
export const isOrgWidePath = (
  pathName: string = window.location.pathname,
): boolean => {
  return orgWidePaths.some((path) => pathName.includes(path));
};
